export default __webpack_public_path__ + "static/media/code.138e5c05.jpeg";